export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter Confirmation Password"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation Password"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Set up the pay-password first in the «Security» section"])}
}